import React from 'react';

const SvgMap = props => (
  <svg viewBox="0 0 20 16" {...props}>
    <path d="M19.7 6.7L13.4.3c-.3-.3-.7-.4-1.1-.2-.4.2-.7.5-.7 1v2.7C4 5 1.1 10.6 0 15.1c-.1.3.1.7.4.8.1.1.2.1.3.1.2 0 .4-.1.6-.3 2.4-3 5.7-4.5 10.4-4.5v2.6c0 .4.3.8.7 1 .4.2.8.1 1.1-.2l6.3-6.4c.3-.4.3-1.1-.1-1.5zm-7 7.1v-2.6c0-.3-.1-.6-.3-.8-.2-.2-.5-.3-.7-.3-4.4.1-7.7 1.4-10.3 4.1 1.2-3.9 4.1-8.4 10.5-9.5.5-.1.9-.5.9-1L12.7 1 19 7.4l-6.3 6.4z" />
  </svg>
)

export default SvgMap;